import axios from 'axios';
import * as Crypto from '../crypt/crypt.js';
import * as Notifiche from './notifiche_model.js';
import * as Auth from '../auth/auth.js';


/*--------------------- OTTENGO LA LISTA DI TUTTE LE NOTIFICHE ---------------------*/
async function getNotifiche(token, sort, orderby){
    try{
        const headers = { 'Authorization': `Bearer ${token}` };
        
        const response = await axios.get(`${Auth.default.url}/notifiche/all`, {params: {sortby: sort, orderby: orderby }, headers });
        let notifiche = JSON.parse(Crypto.decrypt(response.data));

        let data = [];

        for(let notifica of notifiche) {
            data.push(new Notifiche.GetNotificheModel(notifica));
        }

        return {result: true, data: data};
    } catch(e) {
      if(axios.AxiosError && e.response){
        return {result: false, error: Crypto.decrypt(e.response.data)};
      } else {
        return { result: false, error: e.toString() };
      }
  }
}

/*--------------------- CONFERMO NOTIFICA ---------------------*/
async function patchStatoNotifica(token, id_notifica){
  try{    
    const headers = { 'Authorization': `Bearer ${token}`};
    
    const response = await axios.patch(`${Auth.default.url}/notifiche/${id_notifica}/conferma`, {}, { headers });
    
    return { result: true, message: Crypto.decrypt(response.data) };    
  } catch(e) {
    if(axios.AxiosError && e.response){
      return {result: false, error: Crypto.decrypt(e.response.data)};
    } else {
      return { result: false, error: e.toString() };
    }
  }
}

/*--------------------- AGGIUNGO LA NOTA DELLA NOTIFICA ---------------------*/
async function putNotaNotifica(token, id_notifica, nota){
  try{
    const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'text/plain'};
    
    const nuovaNota = new Notifiche.PutNoteNotifica(nota);
    
    const response = await axios.put(`${Auth.default.url}/notifiche/${id_notifica}/note`, Crypto.encrypt(nuovaNota.nota), { headers });
    
    return { result: true, message: Crypto.decrypt(response.data) };
  } catch(e) {
    if(axios.AxiosError && e.response){
      return {result: false, error: Crypto.decrypt(e.response.data)};
    } else {
      return { result: false, error: e.toString() };
    }
  }
}


export default { getNotifiche, patchStatoNotifica, putNotaNotifica };